module.exports = __webpack_public_path__ + "static/media/purpose.9977251d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/assets/purpose.svg
// module id = 5057
// module chunks = 12